/* FRAUENSCHUH - Produktseite Vorschau, Verhalten (v1, 23.09.2026)
   Teil A: fspg  Galerie-Schiene (Ziehen, Wischen, Pfeile, Grossansicht,
                 Bilder folgen der Farbe; das Mausrad scrollt die SEITE,
                 in der Grossansicht vergroessert es das BILD)
   Teil B: fspb  Kaufbalken (Farbe/Groesse, Warenkorb, Mitwandern)
   Vorbild: frauenschuh-preview.netlify.app. ES5-Stil, keine Arrow-Functions.
   Die beiden Teile reden ueber das Ereignis "fspdp:farbe" miteinander. */
(function () {
  'use strict';

  /* 28.10.2026 CH (aus US): Farbname nur fuer die ANZEIGE - fuehrende Ziffern und Leerzeichen
     bis zum ersten Buchstaben fallen weg ("2630 light sky" -> "light sky"). Bleibt
     nichts uebrig, steht der Originalwert da. Gleiche Regel wie snippets/fs-farbname.liquid.
     Niemals fuer Werte (data-wert, Varianten, Warenkorb) verwenden. */
  window.fsFarbname = window.fsFarbname || function (n) {
    var s = String(n == null ? '' : n).trim();
    var r = s.replace(/^[0-9\s]+/, '').trim();
    return r ? r : s;
  };

  function slice(l) { return Array.prototype.slice.call(l); }
  function daten(wurzel, haken) {
    var el = wurzel.querySelector('[' + haken + ']');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var sanft = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;


  /* ------------------------------------------------ Groessentabelle-Fenster */
  /* Beide Knoepfe (Produktinformation und Kaufbalken) oeffnen dasselbe
     Fenster ueber der Seite statt eines neuen Tabs (Wunsch 23.09.2026). */
  var scFenster = null;
  function scStil() {
    if (document.getElementById('fs-sc-stil')) return;
    var st = document.createElement('style');
    st.id = 'fs-sc-stil';
    st.textContent = [
      '.fs-sc{position:fixed;inset:0;z-index:100010;display:none;align-items:center;justify-content:center;padding:4vh 16px;}',
      '.fs-sc.is-offen{display:flex;}',
      '.fs-sc__grund{position:absolute;inset:0;background:rgba(23,23,23,.55);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);border:0;}',
      '.fs-sc__blatt{position:relative;z-index:2;background:#ffffff;border:1px solid #dcdcdc;max-width:min(1000px,94vw);max-height:92vh;display:flex;flex-direction:column;box-shadow:0 24px 60px rgba(23,23,23,.22);}',
      '.fs-sc__kopf{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:14px 16px 12px;border-bottom:1px solid #dcdcdc;}',
      '.fs-sc__titel{font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:#171717;}',
      '.fs-sc__zu{width:34px;height:34px;display:grid;place-items:center;background:none;border:0;cursor:pointer;color:#171717;}',
      '.fs-sc__bild{overflow:auto;padding:14px;}',
      '.fs-sc__bild img{display:block;max-width:100%;height:auto;margin:0 auto;}',
      '@media (max-width:900px){.fs-sc{padding:2vh 8px;}.fs-sc__blatt{max-width:100vw;}}'
    ].join(String.fromCharCode(10));
    document.head.appendChild(st);
  }
  function scZu() {
    if (!scFenster) return;
    scFenster.classList.remove('is-offen');
    document.documentElement.style.overflow = '';
  }
  function scZeigen(url, titel) {
    if (!url) return;
    scStil();
    if (!scFenster) {
      scFenster = document.createElement('div');
      scFenster.className = 'fs-sc';
      scFenster.setAttribute('role', 'dialog');
      scFenster.setAttribute('aria-modal', 'true');
      scFenster.innerHTML =
        '<button class="fs-sc__grund" type="button" data-sc-zu aria-label="' + titel + ' schließen"></button>' +
        '<div class="fs-sc__blatt">' +
          '<div class="fs-sc__kopf">' +
            '<span class="fs-sc__titel" data-sc-titel></span>' +
            '<button class="fs-sc__zu" type="button" data-sc-zu aria-label="Schließen">' +
              '<svg viewBox="0 0 18 18" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M1 1l16 16M17 1L1 17"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="fs-sc__bild"><img alt="" data-sc-bild></div>' +
        '</div>';
      document.body.appendChild(scFenster);
      slice(scFenster.querySelectorAll('[data-sc-zu]')).forEach(function (b) {
        b.addEventListener('click', scZu);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') scZu();
      });
    }
    var bild = scFenster.querySelector('[data-sc-bild]');
    bild.setAttribute('src', url);
    bild.setAttribute('alt', titel);
    scFenster.querySelector('[data-sc-titel]').textContent = titel;
    scFenster.classList.add('is-offen');
    document.documentElement.style.overflow = 'hidden';
    var zu = scFenster.querySelector('.fs-sc__zu');
    if (zu) zu.focus();
  }
  function scKnoepfe(bereich) {
    slice((bereich || document).querySelectorAll('[data-fspi-sizechart],[data-fspb-sizechart]')).forEach(function (b) {
      if (b.dataset.scInit === '1') return;
      b.dataset.scInit = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var text = (b.textContent || '').trim();
        var titel = /gr..entabelle/i.test(text) ? 'Größentabelle' : 'Size chart';
        scZeigen(b.getAttribute('data-datei'), titel);
      });
    });
  }

  /* ---------------------------------------------------------------- Teil A */
  function initGalerie(wurzel) {
    if (wurzel.dataset.fspgInit === '1') return;
    wurzel.dataset.fspgInit = '1';

    var cfg = daten(wurzel, 'data-fspg-daten') || {};
    var track = wurzel.querySelector('[data-fspg-track]');
    var rail = wurzel.querySelector('[data-fspg-rail]');
    var frames = slice(wurzel.querySelectorAll('[data-fspg-frame]'));
    if (!track || !rail) return;

    /* Oberkante messen: Kopfzeile und Ankuendigung sind unterschiedlich hoch */
    function galerieOben() {
      var r = wurzel.getBoundingClientRect();
      var oben = Math.max(0, Math.round(r.top + window.scrollY - window.scrollY));
      if (window.scrollY < 2) wurzel.style.setProperty('--fspg-oben', Math.max(0, Math.round(r.top)) + 'px');
    }
    galerieOben();
    window.addEventListener('resize', galerieOben, { passive: true });
    window.addEventListener('load', galerieOben);

    /* --- Bilder zeigen, sobald die ersten geladen sind (spaetestens 2,5 s) */
    var gezeigt = false;
    function zeigen() {
      if (gezeigt) return;
      gezeigt = true;
      wurzel.classList.add('is-gezeigt');
    }
    /* Nur SICHTBARE Bilder zaehlen: der Farbfilter versteckt sonst eines der
       drei, und die Galerie wartete bis zum Not-Zeitgeber (23.09.2026). */
    var bilder = slice(wurzel.querySelectorAll('.fspg__frame:not(.is-hidden) img')).slice(0, 2);
    var offen = bilder.length;
    if (!offen) zeigen();
    bilder.forEach(function (b) {
      if (b.complete) { offen--; if (offen <= 0) zeigen(); return; }
      b.addEventListener('load', function () { offen--; if (offen <= 0) zeigen(); });
      b.addEventListener('error', function () { offen--; if (offen <= 0) zeigen(); });
    });
    window.setTimeout(zeigen, 2500);

    /* --- Ziehen mit der Maus, Mausrad waagrecht, Pfeile ------------------ */
    var zieht = false, startX = 0, startL = 0, bewegt = 0;
    var erfasst = false, zeigerId = null;
    /* Nachgleiten (23.09.2026): Beim Loslassen laeuft die Schiene mit der
       zuletzt gemessenen Geschwindigkeit weiter und wird sanft langsamer -
       wie beim Wischen am Handy. Am Handy macht das der Browser selbst. */
    var spuren = [], gleitRaf = 0;
    var REIBUNG = 0.94;      /* je Bild 6 Prozent langsamer */
    var MINDEST = 0.02;      /* darunter steht die Schiene */
    var HOECHST = 4.5;       /* Pixel je Millisekunde, deckelt wilde Wische */

    function gleitStopp() {
      if (gleitRaf) { window.cancelAnimationFrame(gleitRaf); gleitRaf = 0; }
    }
    function gleiten(v) {
      /* Unter 900 px rastet die Schiene ein (scroll-snap); dort wuerde das
         Einrasten gegen die Traegheit arbeiten. Am Finger gleitet ohnehin der
         Browser selbst (gemessen 23.09.2026). */
      if (sanft || window.innerWidth <= 900 || Math.abs(v) < 0.08) return;
      var zuletzt = window.performance.now();
      function schritt(jetzt) {
        var dt = Math.min(48, jetzt - zuletzt);
        zuletzt = jetzt;
        var vorher = track.scrollLeft;
        track.scrollLeft = vorher - v * dt;
        endlosPruefen();
        /* am Ende angekommen: aufhoeren statt weiterzurechnen */
        if (Math.abs(track.scrollLeft - vorher) < 0.5 && Math.abs(v) > MINDEST) { gleitRaf = 0; return; }
        v *= Math.pow(REIBUNG, dt / 16.7);
        if (Math.abs(v) < MINDEST) { gleitRaf = 0; pfeileStand(); return; }
        gleitRaf = window.requestAnimationFrame(schritt);
      }
      gleitRaf = window.requestAnimationFrame(schritt);
    }
    function spurMerken(x) {
      var t = window.performance.now();
      spuren.push({ x: x, t: t });
      while (spuren.length > 6 || (spuren.length > 2 && t - spuren[0].t > 120)) spuren.shift();
    }
    function schwung() {
      if (spuren.length < 2) return 0;
      var a = spuren[0], b = spuren[spuren.length - 1];
      var dt = b.t - a.t;
      if (dt < 8) return 0;
      var v = (b.x - a.x) / dt;                    /* Pixel je Millisekunde */
      return Math.max(-HOECHST, Math.min(HOECHST, v));
    }

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      gleitStopp();
      spuren = [];
      spurMerken(e.clientX);
      zieht = true; bewegt = 0; erfasst = false; zeigerId = e.pointerId;
      startX = e.clientX; startL = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!zieht) return;
      var dx = e.clientX - startX;
      bewegt = Math.max(bewegt, Math.abs(dx));
      /* Den Zeiger ERST einfangen, wenn wirklich gezogen wird. Faengt man ihn
         schon beim Druecken ein, landet der anschliessende Klick auf der
         Schiene statt auf dem Bild - die Grossansicht ging dann nie auf
         (gefunden 23.09.2026). */
      if (!erfasst && bewegt > 4) {
        erfasst = true;
        track.classList.add('is-zieht');
        try { track.setPointerCapture(zeigerId); } catch (err) {}
      }
      if (erfasst) track.scrollLeft = startL - dx;
      spurMerken(e.clientX);
    });
    function losLassen() {
      var hatGezogen = erfasst;
      zieht = false;
      if (erfasst) {
        try { track.releasePointerCapture(zeigerId); } catch (err) {}
      }
      erfasst = false;
      track.classList.remove('is-zieht');
      if (hatGezogen) gleiten(schwung());
      spuren = [];
      window.setTimeout(function () { bewegt = 0; }, 60);
    }
    track.addEventListener('pointerup', losLassen);
    track.addEventListener('pointercancel', losLassen);

    /* Kein Mausrad-Umlenken: das Rad scrollt die Seite (Wunsch 23.09.2026).
       Waagrecht bewegt man die Schiene mit Ziehen, Wischen oder den Pfeilen. */

    function schritt(richtung) {
      var breite = track.clientWidth * 0.8;
      if (sanft) { track.scrollLeft += richtung * breite; return; }
      track.scrollTo({ left: track.scrollLeft + richtung * breite, behavior: 'smooth' });
    }
    slice(wurzel.querySelectorAll('[data-fspg-vor]')).forEach(function (b) {
      b.addEventListener('click', function () { gleitStopp(); schritt(parseInt(b.getAttribute('data-fspg-vor'), 10)); });
    });
    function pfeileStand() {
      var l = wurzel.querySelector('[data-fspg-vor="-1"]');
      var r = wurzel.querySelector('[data-fspg-vor="1"]');
      if (endlosAn) { if (l) l.disabled = false; if (r) r.disabled = false; return; }
      var max = track.scrollWidth - track.clientWidth - 2;
      if (l) l.disabled = track.scrollLeft <= 2;
      if (r) r.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', pfeileStand, { passive: true });
    window.addEventListener('resize', pfeileStand, { passive: true });
    pfeileStand();

    /* --- Endlos: nach dem letzten Bild kommt wieder das erste ------------ */
    /* Vor und hinter die Reihe kommt je eine Kopie. Sobald die Schiene eine
       Satzbreite zu weit gewandert ist, springt sie unsichtbar um genau diese
       Breite zurueck - dadurch laeuft sie in beide Richtungen endlos, auch
       waehrend das Nachgleiten laeuft (23.09.2026). */
    var satzBreite = 0, endlosAn = false;

    function klonWeg() {
      slice(rail.querySelectorAll('[data-fspg-klon]')).forEach(function (k) { rail.removeChild(k); });
    }
    function sichtbareOriginale() {
      return frames.filter(function (f) { return !f.classList.contains('is-hidden'); });
    }
    function endlosBauen() {
      if (cfg.endlos === false) return;
      klonWeg();
      endlosAn = false;
      satzBreite = 0;
      var liste = sichtbareOriginale();
      if (liste.length < 2) return;

      var vorne = document.createDocumentFragment();
      var hinten = document.createDocumentFragment();
      liste.forEach(function (f) {
        [vorne, hinten].forEach(function (ziel) {
          var k = f.cloneNode(true);
          k.setAttribute('data-fspg-klon', '1');
          k.setAttribute('aria-hidden', 'true');
          k.setAttribute('tabindex', '-1');
          k.removeAttribute('data-fspg-frame');
          slice(k.querySelectorAll('img')).forEach(function (b) { b.setAttribute('loading', 'lazy'); });
          ziel.appendChild(k);
        });
      });
      rail.insertBefore(vorne, rail.firstChild);
      rail.appendChild(hinten);

      /* Satzbreite = Abstand vom ersten Klon vorne bis zum ersten Original */
      var ersterKlon = rail.querySelector('[data-fspg-klon]');
      var erstesOriginal = liste[0];
      satzBreite = erstesOriginal.offsetLeft - ersterKlon.offsetLeft;
      if (satzBreite <= 0) { klonWeg(); return; }
      endlosAn = true;
      track.scrollLeft = satzBreite;
    }
    function endlosPruefen() {
      if (!endlosAn || satzBreite <= 0) return;
      /* 23.09.2026: Umschlag in der MITTE statt am Rand. Am Rand griff er nie,
         weil der Abstand hinter der letzten Tafel die Schiene kuerzer macht als
         zwei Saetze. Ein Sprung um genau eine Satzbreite ist immer unsichtbar,
         weil dort dasselbe Bild steht. */
      if (track.scrollLeft >= satzBreite * 1.5) track.scrollLeft -= satzBreite;
      else if (track.scrollLeft < satzBreite * 0.5) track.scrollLeft += satzBreite;
    }
    /* 14.10.2026 US (erstWennRuhig): Der Umschlag versetzt scrollLeft um eine
       ganze Satzbreite. Mitten in einem Wisch sah man das als Rutschen. Jetzt
       erst, wenn 140 ms lang kein Scrollen mehr kam - also wenn die Leiste
       wirklich steht. */
    var ruheUhr = 0;
    track.addEventListener('scroll', function () {
      window.clearTimeout(ruheUhr);
      ruheUhr = window.setTimeout(endlosPruefen, 140);
    }, { passive: true });
    /* 14.10.2026 US — NUR BEI ECHTER BREITENAENDERUNG NEU BAUEN.
       Am Telefon blendet der Browser beim Scrollen seine Adressleiste aus und
       wieder ein. Jedes Mal meldet er "resize" - und endlosBauen() riss die
       ganze Schiene auseinander und klonte sie neu. Genau das sah man als
       kurzes Zucken der Bilder beim Scrollen. Die Hoehe aendert sich dabei,
       die BREITE nicht; nur sie ist fuer die Schiene ueberhaupt von Belang. */
    var letzteBreite = window.innerWidth;
    function nurBreiteGeaendert() {
      if (window.innerWidth === letzteBreite) return;
      letzteBreite = window.innerWidth;
      window.setTimeout(endlosBauen, 120);
    }
    window.addEventListener('resize', nurBreiteGeaendert, { passive: true });
    /* Beim Drehen des Geraets aendert sich die Breite oft erst nach dem
       Ereignis - deshalb zusaetzlich mit kurzem Abstand nachsehen. */
    window.addEventListener('orientationchange', function () { window.setTimeout(nurBreiteGeaendert, 250); }, { passive: true });

    /* --- Bilder folgen der Farbe ---------------------------------------- */
    var starts = cfg.colorStarts || {};
    var wechselUhr = 0, wechselLauf = 0, jetzigeFarbe = null;
    /* Wer nach dem Umbau Bescheid wissen muss (die Miniaturen der
       Grossansicht). Frueher haben beide am selben Ereignis gehangen; seit
       der Umbau um 240 ms verzoegert ist, haette der Leuchtkasten sonst noch
       den ALTEN Bildsatz gesehen. */
    var nachUmbau = [];
    function nachFarbe(farbe, sofort) {
      if (!farbe || !starts[farbe]) return;
      /* Dieselbe Farbe noch einmal: nichts tun. Sonst blendet die Galerie
         eine halbe Sekunde weg, ohne dass sich etwas aendert. */
      if (farbe === jetzigeFarbe) return;
      jetzigeFarbe = farbe;
      var namen = Object.keys(starts);
      var werte = namen.map(function (n) { return starts[n]; }).sort(function (a, b) { return a - b; });
      var von = starts[farbe];
      var bis = Infinity;
      for (var i = 0; i < werte.length; i++) { if (werte[i] > von) { bis = werte[i]; break; } }
      function umbauen() {
        frames.forEach(function (f) {
          var p = parseInt(f.getAttribute('data-pos'), 10);
          var drin = p >= von && p < bis;
          f.classList.toggle('is-hidden', !drin);
        });
        gleitStopp();
        track.scrollLeft = 0;
        endlosBauen();
        pfeileStand();
        nachUmbau.forEach(function (fn) { fn(); });
      }
      /* Weicher Wechsel (Wunsch 23.09.2026): ausblenden, im unsichtbaren
         Zustand umbauen, wieder einblenden. Beim ersten Aufbau und bei
         "weniger Bewegung" geht es ohne Blende. */
      if (sofort || sanft) { rail.classList.remove('is-wechselt'); umbauen(); return; }
      rail.classList.add('is-wechselt');
      window.clearTimeout(wechselUhr);
      var meinLauf = ++wechselLauf;
      wechselUhr = window.setTimeout(function () {
        umbauen();
        /* Zwei Bilder warten: der Umbau soll fertig sein, bevor die Schiene
           wieder sichtbar wird, sonst blitzt der alte Stand durch. Nur
           einblenden, wenn inzwischen kein neuer Wechsel angefangen hat -
           sonst blendet die gerade verlassene Farbe noch einmal auf. */
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (meinLauf === wechselLauf) rail.classList.remove('is-wechselt');
          });
        });
      }, 240);
    }
    if (cfg.startFarbe) nachFarbe(cfg.startFarbe, true); else endlosBauen();
    window.addEventListener('load', function () { if (!endlosAn) endlosBauen(); });
    document.addEventListener('fspdp:farbe', function (e) { nachFarbe(e.detail && e.detail.farbe); });

    /* --- Grossansicht: Aufbau wie in der Vorlage frauenschuh-stil --------- */
    var lb = wurzel.querySelector('[data-fspg-lb]');
    if (lb) {
      var buehne = lb.querySelector('[data-fspg-lb-buehne]');
      var minis = slice(lb.querySelectorAll('[data-fspg-lb-thumb]'));
      var zoomWert = lb.querySelector('[data-fspg-zoom-wert]');
      var lbIdx = 0, zoom = 100, schiebt = null, schub = { x: 0, y: 0 };
      /* 16.10.2026 CH: Am Finger darf weiter hinein vergroessert werden als
         mit der Maus - 200 % reichen am Handy nicht, um Material zu sehen. */
      var zoomMax = (window.matchMedia && window.matchMedia('(pointer:coarse)').matches) ? 300 : 200;

      function sichtbareFrames() {
        return frames.filter(function (f) { return !f.classList.contains('is-hidden'); });
      }
      /* Der Schub darf das Bild nicht aus der Buehne schieben. */
      function grenzen() {
        var el = buehne.firstElementChild;
        if (!el) return;
        var s = zoom / 100;
        var b = buehneMasse();
        var maxX = Math.max(0, (el.offsetWidth * s - b.breit) / 2);
        var maxY = Math.max(0, (el.offsetHeight * s - b.hoch) / 2);
        schub.x = Math.min(maxX, Math.max(-maxX, schub.x));
        schub.y = Math.min(maxY, Math.max(-maxY, schub.y));
      }
      /* Das Bild sitzt in der MITTE DES INNENRAUMS der Buehne, nicht in der
         Mitte des Kastens: unter 900 px ist das Polster links 16 px und
         rechts 90 px (Platz fuer die Miniaturen). Wer mit dem ganzen Kasten
         rechnet, verschiebt die Grenzen um 37 px - auf einer Seite bleibt ein
         weisser Streifen, die andere ist nicht erreichbar. */
      function buehneMasse() {
        var cs = window.getComputedStyle(buehne);
        var l = parseFloat(cs.paddingLeft) || 0, r = parseFloat(cs.paddingRight) || 0;
        var o = parseFloat(cs.paddingTop) || 0, u = parseFloat(cs.paddingBottom) || 0;
        var kasten = buehne.getBoundingClientRect();
        return {
          breit: Math.max(0, buehne.clientWidth - l - r),
          hoch: Math.max(0, buehne.clientHeight - o - u),
          mx: kasten.left + l + Math.max(0, buehne.clientWidth - l - r) / 2,
          my: kasten.top + o + Math.max(0, buehne.clientHeight - o - u) / 2
        };
      }
      function zoomAnwenden() {
        var el = buehne.firstElementChild;
        if (el) {
          /* Erst schieben, dann vergroessern: so ist der Schub in echten
             Bildschirm-Pixeln gerechnet und das Bild laeuft beim Ziehen genau
             mit dem Zeiger mit. Vorher stand translate INNERHALB von scale,
             da lief es um den Zoomfaktor zu schnell. */
          el.style.transform = 'translate(' + Math.round(schub.x) + 'px,' + Math.round(schub.y) + 'px) scale(' + (zoom / 100) + ')';
          el.style.cursor = zoom >= 200 ? 'zoom-out' : 'zoom-in';
        }
        if (zoomWert) zoomWert.textContent = zoom + '%';
      }
      /* Vergroessern an einer Stelle: der Punkt unter dem Zeiger bleibt stehen.
         Ohne px/py wird von der Mitte aus vergroessert (Knoepfe, Tastatur). */
      function zoomAnPunkt(neu, px, py) {
        var el = buehne.firstElementChild;
        if (!el) return;
        neu = Math.min(zoomMax, Math.max(100, Math.round(neu)));
        if (neu === zoom) return;
        /* Die Mitte aus dem LAYOUT nehmen, nicht aus getBoundingClientRect:
           waehrend der 0,25-s-Bewegung liefert der Kasten einen Zwischenstand,
           und der Punkt unter dem Zeiger wanderte beim schnellen Radzoom. Das
           Bild sitzt mittig im Innenraum der Buehne, also ist dessen Mitte
           zugleich die unverschobene Mitte des Bildes. */
        var b = buehneMasse();
        var mx = b.mx, my = b.my;
        if (px === undefined || px === null) { px = mx + schub.x; py = my + schub.y; }
        var s = zoom / 100, s2 = neu / 100;
        schub = {
          x: px - mx - (px - mx - schub.x) * s2 / s,
          y: py - my - (py - my - schub.y) * s2 / s
        };
        zoom = neu;
        if (zoom === 100) schub = { x: 0, y: 0 }; else grenzen();
        zoomAnwenden();
      }
      function minisAuffrischen() {
        var liste = sichtbareFrames();
        var erlaubt = {};
        liste.forEach(function (f) { erlaubt[f.getAttribute('data-pos')] = true; });
        var lfd = 0;
        minis.forEach(function (m) {
          var pos = m.getAttribute('data-pos');
          var drin = !!erlaubt[pos];
          m.classList.toggle('is-hidden', !drin);
          if (drin) {
            m.classList.toggle('is-aktiv', lfd === lbIdx);
            lfd++;
          } else {
            m.classList.remove('is-aktiv');
          }
        });
      }
      function zeige(i) {
        var liste = sichtbareFrames();
        if (!liste.length) return;
        i = ((i % liste.length) + liste.length) % liste.length;
        lbIdx = i;
        zoom = 100; schub = { x: 0, y: 0 };
        var quelle = liste[i].querySelector('img, video');
        buehne.innerHTML = '';
        if (quelle) {
          var klon = quelle.cloneNode(true);
          klon.removeAttribute('style');
          klon.removeAttribute('loading');
          if (klon.tagName === 'VIDEO') { klon.setAttribute('controls', ''); klon.muted = true; }
          buehne.appendChild(klon);
          /* Scharf bleiben beim Vergroessern (23.09.2026): in der Schiene laedt
             der Browser wegen sizes=32vw nur die kleine Datei. Die grosse wird
             im Hintergrund geholt und erst eingesetzt, wenn sie da ist - so
             steht sofort ein Bild da und es flackert nicht. */
          var gross = klon.tagName === 'IMG' ? klon.getAttribute('data-gross') : null;
          if (gross) {
            var vorlader = new window.Image();
            vorlader.onload = function () {
              if (buehne.firstElementChild !== klon) return;
              klon.removeAttribute('srcset');
              klon.removeAttribute('sizes');
              klon.setAttribute('src', gross);
            };
            vorlader.src = gross;
          }
        }
        minisAuffrischen();
        zoomAnwenden();
      }
      function lbAuf(i) {
        lb.classList.add('is-offen');
        lb.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        zeige(i);
      }
      function lbZu() {
        lb.classList.remove('is-offen');
        lb.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      }

      frames.forEach(function (f) {
        f.addEventListener('click', function () {
          if (bewegt > 5) return;
          lbAuf(sichtbareFrames().indexOf(f));
        });
      });
      /* Auch die Kopien der Endlos-Schiene sollen die Grossansicht oeffnen. */
      rail.addEventListener('click', function (e) {
        var klon = e.target.closest ? e.target.closest('[data-fspg-klon]') : null;
        if (!klon || bewegt > 5) return;
        var pos = klon.getAttribute('data-pos');
        var liste = sichtbareFrames();
        for (var n = 0; n < liste.length; n++) {
          if (liste[n].getAttribute('data-pos') === pos) { lbAuf(n); return; }
        }
      });
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          var sichtbar = minis.filter(function (x) { return !x.classList.contains('is-hidden'); });
          var i = sichtbar.indexOf(m);
          if (i >= 0) zeige(i);
        });
      });
      slice(lb.querySelectorAll('[data-fspg-lb-vor]')).forEach(function (b) {
        b.addEventListener('click', function () {
          zeige(lbIdx + parseInt(b.getAttribute('data-fspg-lb-vor'), 10));
        });
      });
      var zuKnopf = lb.querySelector('[data-fspg-lb-zu]');
      if (zuKnopf) zuKnopf.addEventListener('click', lbZu);
      slice(lb.querySelectorAll('[data-fspg-zoom]')).forEach(function (b) {
        b.addEventListener('click', function () {
          zoomAnPunkt(zoom + parseInt(b.getAttribute('data-fspg-zoom'), 10));
        });
      });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-offen')) return;
        if (e.key === 'Escape') lbZu();
        if (e.key === 'ArrowRight') zeige(lbIdx + 1);
        if (e.key === 'ArrowLeft') zeige(lbIdx - 1);
        if (e.key === '+' || e.key === '-') zoomAnPunkt(zoom + (e.key === '+' ? 25 : -25));
      });

      /* Zwei-Finger-Zoom (Handy und Tablet), 16.10.2026 CH: Die Buehne traegt
         touch-action:none, damit Wischen und Schieben ueber Zeiger-Ereignisse
         laufen. Dadurch kam die Kneif-Geste nie beim Browser an - am Handy liess
         sich das grosse Bild nur durch Tippen vergroessern. Wir rechnen die Geste
         jetzt selbst auf den vorhandenen Zoom um; der Punkt zwischen den Fingern
         bleibt stehen, genau wie beim Radzoom mit der Maus. */
      var kneift = false, kneifAbstand = 0, kneifZoom = 100;
      function fingerAbstand(t) {
        var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      buehne.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 2) return;
        kneift = true; wisch = null; schiebt = null; schubStart = null;
        buehne.classList.remove('is-schiebt');
        kneifAbstand = fingerAbstand(e.touches);
        kneifZoom = zoom;
        e.preventDefault();
      }, { passive: false });
      buehne.addEventListener('touchmove', function (e) {
        if (!kneift || e.touches.length !== 2 || !kneifAbstand) return;
        e.preventDefault();
        zoomAnPunkt(kneifZoom * (fingerAbstand(e.touches) / kneifAbstand),
          (e.touches[0].clientX + e.touches[1].clientX) / 2,
          (e.touches[0].clientY + e.touches[1].clientY) / 2);
      }, { passive: false });
      function kneifEnde(e) {
        if (!kneift || (e.touches && e.touches.length >= 2)) return;
        kneifAbstand = 0;
        gewischt = Date.now();   /* der letzte abgehobene Finger darf nicht blaettern */
        window.setTimeout(function () { kneift = false; }, 150);
      }
      buehne.addEventListener('touchend', kneifEnde);
      buehne.addEventListener('touchcancel', kneifEnde);

      /* Wischen (bei 100 %) und Schieben (vergroessert) */
      var wisch = null, gewischt = 0;
      var schubStart = null, druckZiel = null;
      buehne.addEventListener('pointerdown', function (e) {
        if (kneift) return;   /* zweiter Finger: das ist Zoomen, kein Wischen */
        /* 23.09.2026: setPointerCapture unten biegt das Ziel des spaeteren
           Klicks auf die Buehne um - der Klick AUFS BILD kam deshalb als
           "daneben geklickt" an und schloss die Ansicht, statt zu
           vergroessern. Wir merken uns hier, worauf wirklich gedrueckt wurde. */
        druckZiel = e.target;
        if (zoom > 100) {
          schiebt = { x: e.clientX - schub.x, y: e.clientY - schub.y };
          schubStart = { x: e.clientX, y: e.clientY };
          buehne.classList.add('is-schiebt');
          if (buehne.firstElementChild) buehne.firstElementChild.style.cursor = 'grabbing';
          e.preventDefault();
        } else { wisch = { x: e.clientX, y: e.clientY }; }
        try { buehne.setPointerCapture(e.pointerId); } catch (err) {}
      });
      buehne.addEventListener('pointermove', function (e) {
        if (kneift || !schiebt) return;
        schub = { x: e.clientX - schiebt.x, y: e.clientY - schiebt.y };
        grenzen();
        zoomAnwenden();
      });
      buehne.addEventListener('pointerup', function (e) {
        /* Wer das vergroesserte Bild geschoben hat, wollte nicht klicken -
           sonst wuerde jedes Schieben am Ende noch eine Stufe vergroessern. */
        if (schiebt && schubStart &&
            (Math.abs(e.clientX - schubStart.x) > 4 || Math.abs(e.clientY - schubStart.y) > 4)) {
          gewischt = Date.now();
        }
        schiebt = null; schubStart = null;
        buehne.classList.remove('is-schiebt');
        zoomAnwenden();
        if (!wisch) return;
        var dx = e.clientX - wisch.x, dy = e.clientY - wisch.y;
        wisch = null;
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) gewischt = Date.now();
        if (zoom > 100) return;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) zeige(lbIdx + (dx < 0 ? 1 : -1));
      });
      buehne.addEventListener('pointercancel', function () { wisch = null; schiebt = null; schubStart = null; druckZiel = null; });
      /* Klick AUF das Bild vergroessert stufenweise (Wunsch 23.09.2026); beim
         dritten Klick geht es zurueck auf 100 %. Nur ein Klick NEBEN das Bild
         schliesst die Grossansicht - vorher tat der Klick aufs Bild nichts,
         und wer knapp danebentraf, stand wieder auf der Produktseite. */
      buehne.addEventListener('click', function (e) {
        var ziel = druckZiel || e.target;
        druckZiel = null;
        if (Date.now() - gewischt < 400) return;
        var el = buehne.firstElementChild;
        if (el && ziel === el && el.tagName !== 'VIDEO') {
          zoomAnPunkt(zoom >= 200 ? 100 : zoom + 50, e.clientX, e.clientY);
          return;
        }
        if (ziel === buehne) lbZu();
      });
      /* Mausrad vergroessert das BILD, nicht die Seite; die Stelle unter dem
         Zeiger bleibt stehen. Ohne preventDefault wandert sonst die Seite
         hinter der Grossansicht. */
      buehne.addEventListener('wheel', function (e) {
        if (!lb.classList.contains('is-offen')) return;
        e.preventDefault();
        var menge = Math.abs(e.deltaY);
        if (e.deltaMode === 1) menge *= 16;        /* Angabe in Zeilen */
        else if (e.deltaMode === 2) menge *= 400;  /* Angabe in Seiten */
        var schritt = Math.max(6, Math.min(40, menge * 0.14));
        zoomAnPunkt(zoom + (e.deltaY < 0 ? schritt : -schritt), e.clientX, e.clientY);
      }, { passive: false });

      /* Farbwechsel: die Miniaturbilder folgen mit - aber ERST nach dem Umbau
         der Schiene. Am Ereignis selbst haengend saehen sie seit der weichen
         Blende noch den alten Bildsatz (der Umbau kommt 240 ms spaeter). */
      nachUmbau.push(function () { lbIdx = 0; minisAuffrischen(); });
      minisAuffrischen();
    }
  }

  /* ---------------------------------------------------------------- Teil B */
  function initBalken(wurzel) {
    if (wurzel.dataset.fspbInit === '1') return;
    wurzel.dataset.fspbInit = '1';

    var cfg = daten(wurzel, 'data-fspb-daten');
    if (!cfg) return;
    var zwang = 0;   /* Zeitpunkt der erzwungenen Breitmachung (Groesse waehlen) */
    var ci = cfg.colorIndex, si = cfg.sizeIndex;
    var stand = { farbe: null, groesse: null };
    var erste = null;
    for (var i = 0; i < cfg.variants.length; i++) {
      if (cfg.variants[i].id === cfg.ersteVerfuegbar) { erste = cfg.variants[i]; break; }
    }
    if (!erste) erste = cfg.variants[0];
    /* 14.10.2026 US: Steht in der Adresse eine Variante (geteilter Link, oder
       der Klick auf eine ausverkaufte Groesse in der Kachel), dann GILT DIESE -
       samt Groesse. Vorher wurde nur die Farbe gesetzt; die Seite zeigte dann
       "Select size", obwohl die Groesse im Link stand, und man landete nicht
       auf dem Benachrichtigen-Knopf. */
    var varianteAusAdresse = null;
    try {
      var vp = new URL(window.location.href).searchParams.get('variant');
      if (vp) {
        for (var vi = 0; vi < cfg.variants.length; vi++) {
          if (String(cfg.variants[vi].id) === String(vp)) { varianteAusAdresse = cfg.variants[vi]; break; }
        }
      }
    } catch (e) { /* ohne URL-Unterstuetzung bleibt es beim Standard */ }
    var start = varianteAusAdresse || erste;
    if (ci > 0 && start) stand.farbe = start['option' + ci];
    if (si > 0 && varianteAusAdresse) stand.groesse = varianteAusAdresse['option' + si];

    var preisEl = wurzel.querySelector('[data-fspb-preis]');
    var farbWert = wurzel.querySelector('[data-fspb-farbwert]');
    var groesseWert = wurzel.querySelector('[data-fspb-groessewert]');
    var tupf = wurzel.querySelector('[data-fspb-tupf]');
    var kauf = wurzel.querySelector('[data-fspb-kauf]');

    function geld(cent) {
      var opts = cfg.mitCent
        ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
        : { maximumFractionDigits: 0 };
      opts.style = 'currency';
      opts.currency = cfg.waehrung || 'EUR';
      try {
        return new Intl.NumberFormat(cfg.sprache === 'de' ? 'de-DE' : 'en-US', opts).format(cent / 100);
      } catch (e) {
        return (cent / 100).toFixed(cfg.mitCent ? 2 : 0);
      }
    }
    function passende() {
      var treffer = null;
      cfg.variants.forEach(function (v) {
        if (ci > 0 && stand.farbe && v['option' + ci] !== stand.farbe) return;
        if (si > 0 && stand.groesse && v['option' + si] !== stand.groesse) return;
        if (si > 0 && !stand.groesse) { if (!treffer) treffer = v; return; }
        if (!treffer) treffer = v;
      });
      return treffer;
    }
    function label(welches) {
      slice(wurzel.querySelectorAll('[data-fspb-label]')).forEach(function (s) {
        s.classList.toggle('is-an', s.getAttribute('data-fspb-label') === welches);
      });
      /* Der Knopf wechselt im Zustand "Benachrichtigen" auf weissen Grund. */
      if (kauf) kauf.classList.toggle('is-melden', welches === 'melden');
    }
    /* 14.10.2026 US: Die gewaehlte Farbe/Groesse gehoert in die Adresszeile.
       Vorher aenderte sich die Adresse nie - wer den Link weitergab, schickte
       immer die Standardfarbe mit. replaceState statt pushState, damit der
       Zurueck-Knopf nicht jede einzelne Farbwahl durchlaufen muss. */
    /* Erst wenn der Kunde selbst gewaehlt hat. Beim Laden darf die Adresse
       NICHT angefasst werden: Ein geteilter Link kann eine bestimmte Groesse
       enthalten, und die wuerde sonst auf die erste Groesse der Farbe
       zurueckgesetzt (gemessen 14.10.: ...207661 wurde zu ...251245). */
    var nutzerHatGewaehlt = false;
    function adresseMitVariante(v) {
      if (!nutzerHatGewaehlt) return;
      if (!v || !v.id || !window.history || !history.replaceState) return;
      try {
        var u = new URL(window.location.href);
        if (u.searchParams.get('variant') === String(v.id)) return;
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.toString());
      } catch (e) { /* alte Browser: dann bleibt die Adresse eben wie sie ist */ }
    }
    function auffrischen() {
      var v = passende();
      adresseMitVariante(v);
      if (v && preisEl) preisEl.textContent = geld(v.price);
      /* Der grosse Preis in der Produktinformation gehoert mitgefuehrt, sonst
         stehen nach einem Variantenwechsel zwei Preise auf der Seite. */
      if (v) {
        slice(document.querySelectorAll('[data-fspi-preis]')).forEach(function (el) {
          el.textContent = geld(v.price);
        });
      }
      if (farbWert && stand.farbe) farbWert.textContent = window.fsFarbname(stand.farbe);
      if (groesseWert) {
        groesseWert.textContent = stand.groesse
          || (cfg.sprache === 'de' ? 'Wählen' : 'Select');
      }
      /* Groessen, die es in dieser Farbe nicht gibt, durchstreichen */
      slice(wurzel.querySelectorAll('[data-fspb-wert="groesse"]')).forEach(function (b) {
        var wert = b.getAttribute('data-wert');
        var da = false;
        /* 15.10.2026 CH: Es gibt Groessen, die in der gewaehlten Farbe gar nicht
           hergestellt werden (Ingrid-ME: 4/XL nur in creme). Fuer die gibt es
           keine Variante und damit auch kein Benachrichtigungs-Formular - der
           Knopf sagte trotzdem "Ausverkauft" und der Kunde kam nicht weiter.
           Solche Groessen stehen jetzt gar nicht erst in der Liste; nur wirklich
           ausverkaufte (Variante vorhanden) bleiben durchgestrichen stehen. */
        var gibtEs = false;
        cfg.variants.forEach(function (v2) {
          if (ci > 0 && stand.farbe && v2['option' + ci] !== stand.farbe) return;
          if (v2['option' + si] !== wert) return;
          gibtEs = true;
          if (v2.available) da = true;
        });
        b.style.display = gibtEs ? '' : 'none';
        b.classList.toggle('is-aus', !da);
        b.setAttribute('aria-pressed', wert === stand.groesse ? 'true' : 'false');
        var st = b.querySelector('[data-fspb-stand]');
        if (st) st.textContent = da ? '' : cfg.texte.aus;
      });
      slice(wurzel.querySelectorAll('[data-fspb-wert="farbe"]')).forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-wert') === stand.farbe ? 'true' : 'false');
        if (b.getAttribute('data-wert') === stand.farbe && tupf) {
          var q = b.querySelector('.fspb__tupf');
          if (q) { tupf.style.backgroundImage = q.style.backgroundImage || ''; tupf.style.backgroundColor = q.style.backgroundColor || ''; }
        }
      });
      if (si > 0 && !stand.groesse) label('waehlen');
      else if (v && v.available) label('kaufen');
      else if (v && restockFormular(v)) label('melden');
      else label('aus');
      /* Wechselt der Kunde auf eine lieferbare Groesse, gehoert das
         Benachrichtigungs-Formular wieder weg - sonst steht es verwaist da. */
      if (!v || v.available) restockVerstecken();
    }

    /* --- Felder auf und zu ---------------------------------------------- */
    function blatt(name) { return wurzel.querySelector('[data-fspb-blatt="' + name + '"]'); }
    function schliessen() {
      slice(wurzel.querySelectorAll('[data-fspb-blatt]')).forEach(function (b) { b.classList.remove('is-offen'); });
      slice(wurzel.querySelectorAll('[data-fspb-feld]')).forEach(function (f) { f.setAttribute('aria-expanded', 'false'); });
    }
    function oeffnen(name) {
      var b = blatt(name);
      if (!b) return;
      var warOffen = b.classList.contains('is-offen');
      schliessen();
      if (warOffen) return;
      b.classList.add('is-offen');
      var f = wurzel.querySelector('[data-fspb-feld="' + name + '"]');
      if (f) f.setAttribute('aria-expanded', 'true');
      var erste2 = b.querySelector('[data-fspb-wert]');
      if (erste2) erste2.focus();
    }
    slice(wurzel.querySelectorAll('[data-fspb-feld]')).forEach(function (f) {
      f.addEventListener('click', function () { oeffnen(f.getAttribute('data-fspb-feld')); });
    });
    document.addEventListener('pointerdown', function (e) {
      if (!wurzel.contains(e.target)) schliessen();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') schliessen();
    });

    slice(wurzel.querySelectorAll('[data-fspb-wert]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var art = b.getAttribute('data-fspb-wert');
        var wert = b.getAttribute('data-wert');
        nutzerHatGewaehlt = true;
        if (art === 'farbe') {
          stand.farbe = wert;
          document.dispatchEvent(new CustomEvent('fspdp:farbe', { detail: { farbe: wert }, bubbles: true }));
        } else {
          /* 14.10.2026 US: Eine ausverkaufte Groesse darf gewaehlt werden -
             sonst bleibt der Knopf auf "Select size" stehen und der Kunde
             kommt nie zur Benachrichtigung. In den Warenkorb legen ist
             weiterhin ausgeschlossen, das prueft der Kauf-Zweig an v.available. */
          stand.groesse = wert;
        }
        auffrischen();
        schliessen();
      });
    });

    var merken = wurzel.querySelector('[data-fspb-merken]');
    if (merken) {
      merken.addEventListener('click', function () {
        var an = merken.getAttribute('aria-pressed') === 'true';
        merken.setAttribute('aria-pressed', an ? 'false' : 'true');
        merken.classList.toggle('is-an', !an);
      });
    }

    /* --- Benachrichtigung bei Wiederverfuegbarkeit (App da-restock) --------
       Die App legt je ausverkaufter Variante ein verstecktes Formular an
       (#da-restock-notification-variant-<id>). Ihre eigene Anzeige-Logik
       haengt an den Standard-Variantenwaehlern des Themes - die hat unsere
       Facelift-Seite nicht. Also blenden wir das passende Formular selbst ein;
       das Absenden macht weiterhin die App. */
    function restockFormular(v) {
      if (!v || !v.id) return null;
      return document.getElementById('da-restock-notification-variant-' + v.id);
    }
    function restockVerstecken() {
      var huelle = document.querySelector('[data-fspi-restock]');
      if (huelle && !huelle.hasAttribute('hidden')) huelle.setAttribute('hidden', '');
    }
    function restockZeigen(v) {
      var form = restockFormular(v);
      if (!form) return false;
      var huelle = document.querySelector('[data-fspi-restock]');
      if (huelle) huelle.removeAttribute('hidden');
      slice(document.querySelectorAll('.da-restock-notification')).forEach(function (f) {
        f.style.display = f === form ? 'block' : 'none';
      });
      var behaelter = document.getElementById('dd-restock-notification-container');
      if (behaelter) behaelter.style.display = 'block';
      try { form.scrollIntoView({ behavior: sanft ? 'auto' : 'smooth', block: 'center' }); } catch (e) { form.scrollIntoView(); }
      var feld = form.querySelector('input[name="email"]');
      if (feld) window.setTimeout(function () { feld.focus(); }, sanft ? 0 : 650);
      return true;
    }

    /* --- In den Warenkorb ------------------------------------------------- */
    if (kauf) {
      kauf.addEventListener('click', function () {
        if (si > 0 && !stand.groesse) {
          /* Erst breit machen, dann das Groessenfeld oeffnen (wie im Vorbild) */
          if (wurzel.classList.contains('is-schmal')) {
            wurzel.classList.remove('is-schmal');
            zwang = Date.now();
            window.setTimeout(function () { oeffnen('groesse'); }, 400);
          } else {
            oeffnen('groesse');
          }
          kauf.classList.add('is-wink');
          window.setTimeout(function () { kauf.classList.remove('is-wink'); }, 500);
          return;
        }
        var v = passende();
        if (v && !v.available) { restockZeigen(v); return; }
        if (!v || !v.available) return;
        kauf.disabled = true;
        window.fetch(cfg.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('fehler');
          label('fertig');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.setTimeout(function () { kauf.disabled = false; auffrischen(); }, 1600);
          if (cfg.zumWarenkorb) window.location.href = cfg.cartUrl;
        }).catch(function () {
          kauf.disabled = false;
          window.location.href = cfg.cartUrl;
        });
      });
    }

    /* --- Mitwandern: schmal ab der Galerie, weg an der Fusszeile ---------- */
    var galerie = document.querySelector('[data-fspg]');
    var fuss = document.querySelector('.shopify-section-group-footer-group')
      || document.querySelector('[class*="footer__outer-wrapper"]')
      || document.querySelector('footer');
    function messen() {
      if (galerie) {
        var unten = galerie.getBoundingClientRect().bottom;
        var schmal = unten <= window.innerHeight * ((cfg.schmalAb || 23) / 100);
        if (Date.now() - zwang > 2000) wurzel.classList.toggle('is-schmal', schmal);
      }
      /* 14.10.2026 US: Der Balken verschwindet jetzt FRUEHER - sobald die
         Ueberschrift der Empfehlungen die Bildschirmmitte erreicht. Wer dort
         angekommen ist, schaut schon auf die naechsten Produkte. Der Fuss
         bleibt als zweite Bedingung stehen (Seiten ohne Empfehlungen). Beides
         haengt bewusst in DIESER Funktion: zwei getrennte Zuhoerer wuerden
         dieselbe Klasse gegeneinander setzen. */
      var empf = document.querySelector('[data-fs-cat] .fs-cat__title') ||
                 document.querySelector('[data-fs-cat] h2');
      var weg = false;
      if (empf) weg = empf.getBoundingClientRect().top <= window.innerHeight / 2;
      if (!weg && fuss) weg = fuss.getBoundingClientRect().top <= window.innerHeight - 90;
      if (empf || fuss) wurzel.classList.toggle('is-weg', weg);
    }
    window.addEventListener('scroll', messen, { passive: true });
    window.addEventListener('resize', messen, { passive: true });
    messen();
    window.setTimeout(function () { wurzel.classList.add('is-sichtbar'); }, sanft ? 0 : 500);

    /* 24.09.2026 — PLATZ FUER DEN NACHRICHTEN-KNOPF.
       Der Chat des Shops schwebt am Handy unten rechts und lag ueber dem
       Kaufknopf. Statt eine Breite zu raten, messen wir den Knopf: --chatplatz
       geht an den Balken, der Kaufknopf endet davor. Ohne Chat bleibt alles
       wie bisher. Der Dienst laedt spaet, deshalb sieht ein Waechter zu. */
    function chatWirtB() {
      /* 14.10.2026 US: Der Dienst liefert heute <shopify-chat>; die beiden
         alten Namen bleiben als Rueckfallebene stehen. */
      return document.querySelector('shopify-chat') || document.querySelector('#ShopifyChat') || document.querySelector('inbox-online-store-chat');
    }
    function chatPlatzMessen() {
      var knopf = wurzel.querySelector('[data-fspb-kauf], .fspb__kauf');
      if (!knopf) return false;
      var h = chatWirtB();
      if (!h) { knopf.style.marginRight = ''; return false; }
      var r = h.getBoundingClientRect();
      var breite = Math.round(r.width);
      /* Steht der Knopf nicht rechts unten, geht er dem Balken nicht in die
         Quere - dann kein Platz. Hat der Wirt keine Groesse (er traegt seinen
         Knopf in einer Schattenwurzel), rechnen wir mit 96 px. */
      var untenRechts = r.bottom > window.innerHeight - 180 && r.right > window.innerWidth - 200;
      if (!breite && h.shadowRoot) breite = 96;
      if (!breite || !untenRechts) { knopf.style.marginRight = ''; return true; }
      /* 14.10.2026 US (chatNurOhneBalken): Am Handy weicht der Kaufknopf dem
         Nachrichten-Knopf nicht mehr aus - der Chat verschwindet dort, solange
         der Balken steht (siehe unten). Der Knopf darf also die volle Breite
         nehmen. Am Schreibtisch bleibt die Luecke wie bisher. */
      if (window.innerWidth <= 900) { knopf.style.marginRight = ''; return true; }
      knopf.style.marginRight = Math.min(160, breite + 12) + 'px';
      return true;
    }
    var chatWacheB = null;
    function chatNachsehenB() {
      if (!chatPlatzMessen()) return false;
      if (chatWacheB) { chatWacheB.disconnect(); chatWacheB = null; }
      return true;
    }
    if (!chatNachsehenB() && window.MutationObserver) {
      chatWacheB = new MutationObserver(chatNachsehenB);
      chatWacheB.observe(document.documentElement, { childList: true, subtree: true });
    }
    /* 14.10.2026 US — DER NACHRICHTEN-KNOPF AUF HOEHE DES KAUF-KNOPFES.
       Am Handy schwebte er ein Stueck ueber dem schwarzen Knopf und wirkte
       dadurch verrutscht. Wir heben ihn so weit an, dass seine Mitte auf der
       Mitte des Kauf-Knopfes liegt. Der urspruengliche Wert wird gemerkt und
       am Schreibtisch wieder eingesetzt - verstellt wird also nichts dauerhaft.
       Laedt der Dienst nicht (oder sitzt er woanders), passiert hier nichts. */
    var chatBottomVorher = null;
    /* Der Dienst haengt seinen Knopf in ein <shopify-chat> mit eigenem
       Shadow-DOM. Das Wirtselement selbst fuellt das ganze Fenster - bewegen
       laesst sich nur der Kasten .activator-nudge DARIN. Darum greifen wir in
       die Schattenwurzel; findet sich dort nichts, bleibt alles unveraendert. */
    /* 15.10.2026 CH - DER KNOPF STECKT EINE EBENE TIEFER.
       Im CH-Shop liefert der Dienst eine neuere Fassung: <shopify-chat>
       enthaelt dort ein <shopify-agent-runtime> mit EIGENER Schattenwurzel,
       und erst DARIN sitzt .activator-nudge. Ein Blick nur in die aeussere
       Wurzel findet nichts - chatKasten() gab NULL zurueck, und damit lief
       die ganze Sichtbarkeits-Logik stumm ins Leere. Darum suchen wir jetzt
       durch alle verschachtelten Schattenwurzeln hindurch. Die alte, flache
       Fassung (US) wird gleich im ersten Schritt gefunden - dort aendert
       sich also nichts. */
    function chatTiefSuchen(wurzel, wahl) {
      var t = wurzel.querySelector(wahl);
      if (t) return t;
      var alle = wurzel.querySelectorAll('*');
      for (var i = 0; i < alle.length; i++) {
        if (alle[i].shadowRoot) {
          var f = chatTiefSuchen(alle[i].shadowRoot, wahl);
          if (f) return f;
        }
      }
      return null;
    }
    function chatKasten() {
      var h = chatWirtB();
      if (!h || !h.shadowRoot) return null;
      return chatTiefSuchen(h.shadowRoot, '.activator-nudge') ||
             (chatTiefSuchen(h.shadowRoot, '.activator') || {}).parentNode || null;
    }
    function chatHoeheAngleichen() {
      var kasten = chatKasten();
      var knopf = wurzel.querySelector('[data-fspb-kauf], .fspb__kauf');
      if (!kasten || !knopf) return;
      if (chatBottomVorher === null) {
        chatBottomVorher = kasten.style.bottom || '';
      }
      if (window.innerWidth > 900) {
        if (chatBottomVorher) kasten.style.setProperty('bottom', chatBottomVorher);
        else kasten.style.removeProperty('bottom');
        return;
      }
      var kr = knopf.getBoundingClientRect();
      var cr = kasten.getBoundingClientRect();
      if (!kr.height || !cr.height) return;
      /* Beide Mittellinien auf eine Hoehe: Abstand der Chat-Unterkante vom
         Fensterboden = Boden minus (Mitte des Kauf-Knopfes + halbe Chat-Hoehe). */
      var ziel = Math.round(window.innerHeight - (kr.top + kr.height / 2) - cr.height / 2);
      if (ziel < 0) ziel = 0;
      kasten.style.setProperty('bottom', ziel + 'px', 'important');
    }
    /* 14.10.2026 US — CHAT UND BALKEN TEILEN SICH DEN PLATZ.
       Am Handy standen beide nebeneinander in derselben Zeile; der Kaufknopf
       musste dafuer schmal bleiben und wirkte gedraengt. Jetzt gilt: solange
       der Balken sichtbar ist, ist der Nachrichten-Knopf ausgeblendet und der
       Kaufknopf nimmt die ganze Breite. Sobald der Balken verschwindet (ganz
       oben auf der Seite oder unten bei den Empfehlungen), kommt der Chat
       zurueck. Am Schreibtisch aendert sich nichts. */
    function chatSichtbarkeit() {
      var kasten = chatKasten();
      if (!kasten) return;
      if (window.innerWidth > 900) {
        kasten.style.removeProperty('opacity');
        kasten.style.removeProperty('pointer-events');
        kasten.style.removeProperty('transition');
        return;
      }
      var balkenDa = wurzel.classList.contains('is-sichtbar') &&
                     !wurzel.classList.contains('is-weg');
      /* Weich ein- und ausblenden statt hartem Verstecken - der Dienst baut
         seinen Knopf sonst neu auf, wenn man display anfasst.
         15.10.2026 CH, gemessen: Traegt der Kasten die endlose Huepf-
         Animation der neuen Fassung (.activator-nudge--active / nudge-bounce),
         dann wird eine Ueberblendung der Deckkraft in jedem Einzelbild neu
         angestossen und steht ewig auf ihrem Anfangswert. Eine LAUFENDE
         Ueberblendung sticht in der Kaskade sogar !important - genau daran
         ist das Ausblenden im CH-Shop bisher gescheitert. Huepft der Kasten,
         blenden wir deshalb ohne Ueberblendung: hart, aber wirksam. Ohne
         Huepfen (US) bleibt die weiche Blende unveraendert. */
      var huepft = false;
      if (kasten.getAnimations) {
        var lauf = kasten.getAnimations();
        for (var i = 0; i < lauf.length; i++) {
          if (lauf[i] && lauf[i].animationName) { huepft = true; break; }
        }
      }
      kasten.style.setProperty('transition', huepft ? 'none' : 'opacity .3s ease', 'important');
      kasten.style.setProperty('opacity', balkenDa ? '0' : '1', 'important');
      kasten.style.setProperty('pointer-events', balkenDa ? 'none' : 'auto', 'important');
    }
    /* 15.10.2026 CH: Der Dienst tauscht seinen Knopf kurz nach dem Laden
       einmal aus - erst steht die alte, flache Fassung da, dann ersetzt er
       sie durch die neue in der tieferen Schattenwurzel. Der neue Knopf
       kommt ohne unsere Regel auf die Seite; ohne Beobachter blitzte er bis
       zum naechsten Zwei-Sekunden-Blick auf. Der Beobachter horcht auf die
       Wurzel, in der der Kasten gerade haengt, und zieht sofort nach. */
    var chatWurzelWache = null;
    var chatWurzelBisher = null;
    function chatWacheWurzel() {
      var kasten = chatKasten();
      if (!kasten || !kasten.getRootNode || !window.MutationObserver) return;
      var w = kasten.getRootNode();
      if (!w || w === chatWurzelBisher) return;
      if (chatWurzelWache) chatWurzelWache.disconnect();
      chatWurzelBisher = w;
      chatWurzelWache = new MutationObserver(function () { chatSichtbarkeit(); });
      chatWurzelWache.observe(w, { childList: true, subtree: true });
    }
    function chatPflegen() { chatWacheWurzel(); chatHoeheAngleichen(); chatSichtbarkeit(); }
    window.addEventListener('resize', chatPflegen, { passive: true });
    window.addEventListener('scroll', chatSichtbarkeit, { passive: true });
    window.setInterval(chatPflegen, 2000);
    window.setTimeout(chatPflegen, 1200);

    window.addEventListener('resize', chatPlatzMessen, { passive: true });
    /* Der Chat kann auch spaeter noch auftauchen oder wieder gehen - ein
       ruhiger Blick alle zwei Sekunden kostet nichts und haelt den Abstand
       richtig. */
    window.setInterval(chatPlatzMessen, 2000);

    auffrischen();
  }

  /* ---------------------------------------------------------------- Teil F */
  /* Complete the Look (fspl): das Kampagnenbild folgt der gewaehlten Farbe.

     Der Auftraggeber will das Modelfoto der AUSGEWAEHLTEN Variante sehen und
     darunter die Produkte aus dem Metafeld "STL-Products" (custom.stl_products).
     Die Produkte liest die Section selbst; hier wechselt nur das Bild, und zwar
     nach derselben Regel wie die Galerie: zu jeder Farbe gehoert das Bild der
     ersten Variante dieser Farbe, die ein eigenes Bild hat. */
  function initLook(wurzel) {
    if (wurzel.dataset.fsplInit === '1') return;
    wurzel.dataset.fsplInit = '1';

    var cfg = daten(wurzel, 'data-fspl-daten') || {};
    var bilder = cfg.farbBilder || {};
    var bild = wurzel.querySelector('[data-fspl-kampagne]');

    /* Am Handy schwebt der Kaufbalken ueber dem Abschnitt. Wieviel Platz er
       braucht, messen wir an ihm selbst - seine Hoehe haengt davon ab, ob
       Farbe und Groesse angeboten werden. Ohne Balken bleibt es beim Wert
       aus dem CSS. */
    function balkenPlatz() {
      var b = document.querySelector('[data-fspb]');
      if (!b || window.innerWidth > 980) { wurzel.style.removeProperty('--fspl-unten'); return; }
      var r = b.getBoundingClientRect();
      if (!r.height) { wurzel.style.removeProperty('--fspl-unten'); return; }
      var unten = Math.max(0, window.innerHeight - r.bottom);
      wurzel.style.setProperty('--fspl-unten', Math.round(r.height + unten + 14) + 'px');
    }
    balkenPlatz();
    window.addEventListener('resize', balkenPlatz, { passive: true });
    var balkenKasten = document.querySelector('[data-fspb]');
    if (balkenKasten && window.ResizeObserver) {
      new ResizeObserver(balkenPlatz).observe(balkenKasten);
    }

    if (!bild) return;

    document.addEventListener('fspdp:farbe', function (e) {
      var farbe = e.detail && e.detail.farbe;
      var neu = farbe ? bilder[farbe] : null;
      if (!neu || !neu.src || bild.getAttribute('src') === neu.src) return;
      /* Erst laden, dann tauschen - sonst blitzt eine Luecke auf. */
      var vor = new window.Image();
      vor.onload = function () {
        bild.classList.add('is-wechselt');
        window.setTimeout(function () {
          bild.removeAttribute('srcset');
          bild.removeAttribute('sizes');
          bild.setAttribute('src', neu.src);
          if (neu.w) bild.setAttribute('width', neu.w);
          if (neu.h) bild.setAttribute('height', neu.h);
          bild.classList.remove('is-wechselt');
        }, sanft ? 0 : 170);
      };
      vor.src = neu.src;
    });
  }

  /* ---------------------------------------------------------------- Teil C */
  /* Klappzeilen der Produktinformation (fspi) */
  function initInfo(wurzel) {
    if (wurzel.dataset.fspiInit === '1') return;
    wurzel.dataset.fspiInit = '1';
    var zeilen = slice(wurzel.querySelectorAll('[data-fspi-row]'));
    /* Setzt eine Zeile auf/zu inkl. Hoehenmessung, aria und Hinweis-Text. */
    function stelle(zeile, offen) {
      zeile.classList.toggle('is-open', offen);
      var knopf = zeile.querySelector('[data-fspi-toggle]');
      var clip = zeile.querySelector('.fspi-row__clip');
      if (knopf) knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
      /* Hoehe messen statt auf CSS-Tricks zu bauen: 0 -> gemessen -> auto */
      if (clip) {
        if (offen) {
          clip.style.height = clip.scrollHeight + 'px';
          window.setTimeout(function () {
            if (zeile.classList.contains('is-open')) clip.style.height = 'auto';
          }, sanft ? 0 : 400);
        } else {
          clip.style.height = clip.scrollHeight + 'px';
          void clip.offsetHeight;
          clip.style.height = '0px';
        }
      }
      var hinweis = zeile.querySelector('[data-fspi-hinweis]');
      if (hinweis) {
        hinweis.textContent = offen
          ? hinweis.getAttribute('data-auf')
          : hinweis.getAttribute('data-zu');
      }
    }
    zeilen.forEach(function (zeile) {
      var knopf = zeile.querySelector('[data-fspi-toggle]');
      if (!knopf) return;
      knopf.addEventListener('click', function () {
        var aufmachen = !zeile.classList.contains('is-open');
        /* FS-Facelift (PDF): immer nur EINE Zeile offen -> andere zuerst zu. */
        zeilen.forEach(function (andere) {
          if (andere !== zeile && andere.classList.contains('is-open')) stelle(andere, false);
        });
        stelle(zeile, aufmachen);
      });
    });
  }

  /* ---------------------------------------------------------------- Teil D */
  /* Kopfzeile mit Mega-Feld (fskz) */
  function initKopf(wurzel) {
    if (wurzel.dataset.fskzInit === '1') return;
    wurzel.dataset.fskzInit = '1';

    var cfg = daten(wurzel, 'data-fskz-daten') || {};
    var punkte = slice(wurzel.querySelectorAll('[data-fskz-punkt]'));
    var felder = slice(wurzel.querySelectorAll('[data-fskz-feld]'));
    var bar = wurzel.querySelector('.fskz__bar');
    var offenerIndex = null;
    var weckerAuf = 0, weckerZu = 0;

    function feldFuer(i) {
      for (var k = 0; k < felder.length; k++) {
        if (felder[k].getAttribute('data-fskz-feld') === String(i)) return felder[k];
      }
      return null;
    }
    function zumachen() {
      window.clearTimeout(weckerAuf); window.clearTimeout(weckerZu);
      felder.forEach(function (f) { f.classList.remove('is-offen'); });
      punkte.forEach(function (p) {
        p.classList.remove('is-offen');
        if (p.getAttribute('aria-haspopup')) p.setAttribute('aria-expanded', 'false');
      });
      wurzel.classList.remove('is-offen');
      offenerIndex = null;
    }
    function aufmachen(i) {
      var feld = feldFuer(i);
      if (!feld) { zumachen(); return; }
      felder.forEach(function (f) { f.classList.remove('is-offen'); });
      punkte.forEach(function (p) {
        var an = p.getAttribute('data-fskz-punkt') === String(i);
        p.classList.toggle('is-offen', an);
        if (p.getAttribute('aria-haspopup')) p.setAttribute('aria-expanded', an ? 'true' : 'false');
      });
      feld.classList.add('is-offen');
      wurzel.classList.add('is-offen');
      werbebildLaden(i);
      bildBreiten();
      wurzel.classList.remove('is-eingefahren');
      offenerIndex = i;
    }
    function spaeterAuf(i) {
      window.clearTimeout(weckerAuf); window.clearTimeout(weckerZu);
      var wartezeit = offenerIndex === null ? (cfg.aufAuf || 90) : (cfg.aufWechsel || 60);
      weckerAuf = window.setTimeout(function () { aufmachen(i); }, sanft ? 0 : wartezeit);
    }
    function spaeterZu() {
      window.clearTimeout(weckerAuf); window.clearTimeout(weckerZu);
      weckerZu = window.setTimeout(zumachen, sanft ? 0 : (cfg.zu || 180));
    }

    punkte.forEach(function (p) {
      var i = p.getAttribute('data-fskz-punkt');
      var hatFeld = !!feldFuer(i);
      p.addEventListener('mouseenter', function () {
        if (window.innerWidth <= 900) return;
        if (hatFeld) { werbebildLaden(i); spaeterAuf(i); } else { spaeterZu(); }
      });
      /* Tastatur: der Link bleibt ein Link, Pfeil nach unten oeffnet das Feld */
      p.addEventListener('keydown', function (e) {
        if (!hatFeld) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          werbebildLaden(i);
          aufmachen(i);
          /* Ohne das steht der Fokus weiter in der Leiste und der naechste
             Tabulator schliesst das eben geoeffnete Feld wieder. */
          var feld = feldFuer(i);
          var erster = feld ? feld.querySelector('a') : null;
          if (erster) erster.focus();
        }
        if (e.key === 'Escape') { zumachen(); p.focus(); }
      });
      p.addEventListener('focus', function () {
        if (window.innerWidth <= 900) return;
        if (hatFeld) aufmachen(i); else zumachen();
      });
    });

    felder.forEach(function (f) {
      f.addEventListener('mouseenter', function () {
        window.clearTimeout(weckerZu);
      });
    });
    wurzel.addEventListener('mouseleave', spaeterZu);
    wurzel.addEventListener('focusout', function (e) {
      if (!wurzel.contains(e.relatedTarget)) zumachen();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') zumachen();
    });

    /* Breite der Werbebilder: Hoehe des Menues mal Seitenverhaeltnis. So wird
       das Bild ganz gezeigt, beruehrt oben und unten den Rand und bestimmt
       nicht selbst die Hoehe des Menues (23.09.2026). */
    function bildBreiten() {
      slice(wurzel.querySelectorAll('[data-fskz-feld]')).forEach(function (feld) {
        var figur = feld.querySelector('.fskz__werbung');
        var bild = figur ? figur.querySelector('img') : null;
        if (!figur || !bild) return;
        var gruppen = feld.querySelector('.fskz__gruppen');
        if (!gruppen) return;
        var war = feld.classList.contains('is-offen');
        if (!war) { feld.style.visibility = 'hidden'; feld.style.display = 'block'; }
        var hoehe = figur.getBoundingClientRect().height;
        if (!war) { feld.style.display = ''; feld.style.visibility = ''; }
        /* 23.09.2026: Bisher kam das Verhaeltnis aus der GELADENEN Datei. Die
           Werbebilder laden aber erst beim Oeffnen - beim Rechnen war
           naturalWidth 0, es galt der Notwert 0,75 und das Bild bekam Raender.
           Die Attribute width/height stehen von Anfang an im Markup. */
        var aw = parseFloat(bild.getAttribute('width')) || bild.naturalWidth;
        var ah = parseFloat(bild.getAttribute('height')) || bild.naturalHeight;
        var verhaeltnis = (aw && ah) ? aw / ah : 0.75;
        if (hoehe > 0) {
          figur.style.setProperty('--fskz-bildbreite', Math.round(hoehe * verhaeltnis) + 'px');
        }
      });
    }
    bildBreiten();
    window.addEventListener('resize', bildBreiten, { passive: true });
    slice(wurzel.querySelectorAll('.fskz__werbung img')).forEach(function (b) {
      if (!b.complete) b.addEventListener('load', bildBreiten);
    });

    /* Sprachwahl selbst verdrahten: das Theme-JS kennt nur seine eigene
       Kopfzeile, die hier abgeschaltet ist (23.09.2026). */
    slice(wurzel.querySelectorAll('[data-disclosure-toggle]')).forEach(function (knopf) {
      var huelle = knopf.closest('[data-disclosure]');
      var liste = huelle ? huelle.querySelector('[data-disclosure-list], ul, .disclosure-list') : null;
      if (!huelle || !liste) return;
      liste.hidden = true;
      knopf.setAttribute('aria-expanded', 'false');
      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        var offen = liste.hidden;
        liste.hidden = !offen;
        knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
        huelle.classList.toggle('is-visible', offen);
      });
      document.addEventListener('pointerdown', function (e) {
        if (huelle.contains(e.target)) return;
        liste.hidden = true;
        knopf.setAttribute('aria-expanded', 'false');
        huelle.classList.remove('is-visible');
      });
    });

    /* Werbebilder erst anstupsen, wenn der Punkt das erste Mal ueberfahren wird */
    function werbebildLaden(i) {
      var feld = feldFuer(i);
      if (!feld) return;
      slice(feld.querySelectorAll('[data-fskz-werbebild]')).forEach(function (b) {
        if (b.dataset.fskzGeladen === '1') return;
        b.dataset.fskzGeladen = '1';
        b.setAttribute('decoding', 'async');
        b.addEventListener('load', function () { bildBreiten(); }, { once: true });
        if (b.getAttribute('data-quellen')) b.setAttribute('srcset', b.getAttribute('data-quellen'));
        if (b.getAttribute('data-quelle')) b.setAttribute('src', b.getAttribute('data-quelle'));
      });
    }

    /* Handy-Menue */
    var burger = wurzel.querySelector('[data-fskz-burger]');
    var mobil = wurzel.querySelector('[data-fskz-mobil]');
    /* Hoehe des Handy-Menues: vom unteren Rand der Leiste bis zum Fensterende */
    function mobilHoehe() {
      if (!bar) return;
      var unten = bar.getBoundingClientRect().bottom;
      wurzel.style.setProperty('--fskz-mobilhoehe', Math.max(240, Math.round(window.innerHeight - unten)) + 'px');
    }
    mobilHoehe();
    window.addEventListener('resize', mobilHoehe, { passive: true });
    window.addEventListener('scroll', mobilHoehe, { passive: true });

    if (burger && mobil) {
      burger.addEventListener('click', function () {
        var offen = mobil.classList.toggle('is-offen');
        wurzel.classList.toggle('is-menue', offen);
        mobilHoehe();
        burger.setAttribute('aria-expanded', offen ? 'true' : 'false');
        burger.setAttribute('aria-label', offen ? 'Schließen' : 'Menü');
        document.documentElement.style.overflow = offen ? 'hidden' : '';
      });
      /* Escape schliesst das Handy-Menue */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !mobil.classList.contains('is-offen')) return;
        mobil.classList.remove('is-offen');
        wurzel.classList.remove('is-menue');
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Menü');
        document.documentElement.style.overflow = '';
      });
    }

    /* Warenkorb-Zahl frisch halten: das Theme-JS aktualisiert nur Zaehler
       INNERHALB seiner eigenen Kopfzeile (theme.js: [data-js-cart-count] im
       Section-Container). Unsere steht ausserhalb, also selbst nachfragen. */
    var korb = wurzel.querySelector('[data-fskz-korb]');
    if (korb && window.fetch) {
      var korbHolen = function () {
        window.fetch(cfg.korbJs || '/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (w) {
            if (!w || typeof w.item_count !== 'number') return;
            korb.textContent = w.item_count;
            if (w.item_count > 0) korb.removeAttribute('hidden');
            else korb.setAttribute('hidden', 'hidden');
          })
          .catch(function () {});
      };
      ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach(function (ev) {
        document.addEventListener(ev, korbHolen);
      });
      window.addEventListener('pageshow', korbHolen);
    }

    /* Einfahren: 2 px abwaerts versteckt, 8 px aufwaerts oder ganz oben zeigt */
    if (cfg.einfahren !== false) {
      var letzte = window.scrollY, wende = window.scrollY, abwaerts = true;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        var jetztAb = y > letzte;
        if (jetztAb !== abwaerts) { abwaerts = jetztAb; wende = y; }
        letzte = y;
        if (offenerIndex !== null) return;
        if (mobil && mobil.classList.contains('is-offen')) return;
        if (y <= 0 || (!abwaerts && wende - y > 8)) {
          wurzel.classList.remove('is-eingefahren');
        } else if (abwaerts && y - wende > 2 && y > (bar ? bar.offsetHeight : 74)) {
          wurzel.classList.add('is-eingefahren');
        }
      }, { passive: true });
    }
  }

  /* ---------------------------------------------------------------- Teil E */
  /* Material-Inszenierung (fspm): Kapitel blaettern, Bildausschnitt wandert */
  function initMaterial(wurzel) {
    if (wurzel.dataset.fspmInit === '1') return;
    wurzel.dataset.fspmInit = '1';

    var cfg = daten(wurzel, 'data-fspm-daten') || {};
    var anzahl = cfg.kapitel || 0;
    if (anzahl < 1) return;

    var bilder = slice(wurzel.querySelectorAll('[data-fspm-bild]'));
    var saetze = slice(wurzel.querySelectorAll('[data-fspm-satz]'));
    var texte = slice(wurzel.querySelectorAll('[data-fspm-textsatz]'));
    var fenster = wurzel.querySelector('[data-fspm-fenster]');
    var dunst = wurzel.querySelector('[data-fspm-dunst]');
    var marke = wurzel.querySelector('[data-fspm-marke]');
    var zaehler = wurzel.querySelector('[data-fspm-zaehler]');
    var jetzt = 0;

    /* Der Dunst ist eine unscharfe Kopie der Bilder hinter dem Fenster. */
    if (dunst && !dunst.children.length) {
      bilder.forEach(function (b) {
        var k = b.cloneNode(true);
        k.removeAttribute('data-fspm-bild');
        k.setAttribute('data-fspm-dunstbild', b.getAttribute('data-fspm-bild'));
        slice(k.querySelectorAll('img')).forEach(function (i) {
          i.setAttribute('loading', 'lazy');
          i.removeAttribute('srcset');
          i.removeAttribute('sizes');
          /* Die Kopie ist unscharf und klein - sie darf nicht die grosse Datei
             laden (gemessen 23.09.2026: sie war groesser als das Original). */
          var q = i.getAttribute('src') || '';
          /* 23.09.2026: Hier fehlte der Rueckstrich vor dem d - der Ausdruck
             traf nie zu, die unscharfen Kopien luden weiter die grosse Datei. */
          i.setAttribute('src', q.replace(/([?&]width=)\d+/, '$1400'));
        });
        dunst.appendChild(k);
      });
    }
    var dunstBilder = dunst ? slice(dunst.querySelectorAll('[data-fspm-dunstbild]')) : [];

    function quelle(i) {
      var b = bilder[i] ? bilder[i].querySelector('img') : null;
      return b ? b.getAttribute('src') : '';
    }
    function zeigeKapitel(i, richtung) {
      if (i < 0 || i > anzahl - 1 || i === jetzt) return;
      var gleichesBild = quelle(i) === quelle(jetzt);
      var dauer = gleichesBild ? (cfg.dauerGleich || 1400) : (cfg.dauerWechsel || 2000);
      wurzel.style.setProperty('--fspm-dauer', (sanft ? 0 : dauer) + 'ms');

      bilder.concat(dunstBilder).forEach(function (b) {
        var nr = parseInt(b.getAttribute('data-fspm-bild') || b.getAttribute('data-fspm-dunstbild'), 10);
        b.classList.toggle('is-da', nr === i);
      });

      /* Ueberschrift und Text tauschen, alte Fassung laeuft aus */
      [[saetze, 'fspm__titelsatz'], [texte, 'fspm__textsatz']].forEach(function (paar) {
        var liste = paar[0];
        liste.forEach(function (el, nr) {
          if (nr === i) {
            el.hidden = false;
            el.classList.remove('is-weg');
            el.classList.add('is-da');
            el.setAttribute('data-richtung', richtung < 0 ? 'hoch' : 'runter');
          } else if (nr === jetzt) {
            el.classList.remove('is-da');
            el.classList.add('is-weg');
            window.setTimeout(function () {
              if (!el.classList.contains('is-da')) { el.hidden = true; el.classList.remove('is-weg'); }
            }, sanft ? 0 : 560);
          } else {
            el.hidden = true;
            el.classList.remove('is-da', 'is-weg');
          }
        });
      });

      jetzt = i;
      if (marke) marke.style.setProperty('--schritt', i);
      if (zaehler) zaehler.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + anzahl).slice(-2);
      slice(wurzel.querySelectorAll('[data-fspm-vor]')).forEach(function (b) {
        var r = parseInt(b.getAttribute('data-fspm-vor'), 10);
        b.disabled = (r < 0 && jetzt === 0) || (r > 0 && jetzt === anzahl - 1);
      });
    }

    slice(wurzel.querySelectorAll('[data-fspm-vor]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var r = parseInt(b.getAttribute('data-fspm-vor'), 10);
        zeigeKapitel(jetzt + r, r);
      });
    });

    /* Ziehen und Wischen im Fenster */
    if (fenster) {
      var start = null, gezogen = 0;
      fenster.addEventListener('pointerdown', function (e) {
        start = e.clientX; gezogen = 0;
        fenster.classList.add('is-zieht');
        try { fenster.setPointerCapture(e.pointerId); } catch (err) {}
      });
      fenster.addEventListener('pointermove', function (e) {
        if (start === null) return;
        gezogen = e.clientX - start;
      });
      function fertig() {
        if (start === null) return;
        start = null;
        fenster.classList.remove('is-zieht');
        var schwelle = Math.max(60, fenster.getBoundingClientRect().width * 0.16);
        if (Math.abs(gezogen) > schwelle) zeigeKapitel(jetzt + (gezogen < 0 ? 1 : -1), gezogen < 0 ? 1 : -1);
        gezogen = 0;
      }
      fenster.addEventListener('pointerup', fertig);
      fenster.addEventListener('pointercancel', fertig);
      fenster.setAttribute('tabindex', '0');
      fenster.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); zeigeKapitel(jetzt + 1, 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); zeigeKapitel(jetzt - 1, -1); }
      });
    }

    /* Die Ueberschrift darf nie mitten im Satz umbrechen. Gemessen am
       23.09.2026 bei 1440 px: die Spalte ist 405 px breit, "Das Gewebe."
       braucht 424 px und "Die Passform." 429 px - beide standen zweizeilig
       da, "Charakter in" ebenso. Wir messen die laengste Zeile ALLER Kapitel
       und setzen EINE Groesse fuer den ganzen Abschnitt, damit die Kapitel
       beim Blaettern gleich gross bleiben. Die Vorgabe aus dem CSS (clamp)
       ist die Obergrenze, 30 px die Untergrenze; reicht auch das nicht, darf
       die Zeile umbrechen. */
    var titel = wurzel.querySelector('[data-fspm-titel]');
    var messLeinwand = null;
    var letzteSpalte = -1;
    function titelAnpassen(erzwungen) {
      if (!titel) return;
      /* Den verfuegbaren Platz messen, nicht die eigene Breite: unter 900 px
         steht das Raster auf justify-items:start, der Kasten schrumpft also
         auf seinen Inhalt. Die Routine haette sich selbst gemessen und die
         Schrift ohne Not verkleinert (gemessen 23.09.2026 bei 390 px:
         179 px statt der frei stehenden Spalte). Deshalb bekommt die
         Rasterzelle fuer die Dauer der Messung volle Breite. */
      var zelle = titel.parentNode && titel.parentNode.style ? titel.parentNode : null;
      var alteBreite = zelle ? zelle.style.width : '';
      if (zelle) zelle.style.width = '100%';
      var platz = titel.clientWidth;
      if (zelle) zelle.style.width = alteBreite;
      if (!platz) return;
      if (!erzwungen && platz === letzteSpalte) return;
      letzteSpalte = platz;
      titel.style.fontSize = '';
      var stil = window.getComputedStyle(titel);
      var gross = parseFloat(stil.fontSize);
      if (!gross) return;
      if (!messLeinwand) {
        var lw = document.createElement('canvas');
        messLeinwand = lw.getContext ? lw.getContext('2d') : null;
      }
      if (!messLeinwand) return;
      var noetig = 0;
      slice(wurzel.querySelectorAll('.fspm__zeile span')).forEach(function (s) {
        var t = (s.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) return;
        /* Je Zeile die Schrift nehmen, die WIRKLICH gerendert wird: die
           Ueberschrift nennt zwar eine Schriftfamilie, die Zeilen darin
           erben aber eine andere (gemessen 23.09.2026: h2 Garamond,
           Zeile Frutiger - mit der falschen Familie fiel die Messung um
           rund 20 px zu kurz aus). */
        var zs = window.getComputedStyle(s);
        var zg = parseFloat(zs.fontSize) || gross;
        messLeinwand.font = zs.fontStyle + ' ' + zs.fontWeight + ' ' + zg + 'px ' + zs.fontFamily;
        var sperre = parseFloat(zs.letterSpacing) || 0;
        var b = (messLeinwand.measureText(t).width + sperre * t.length) * (gross / zg);
        if (b > noetig) noetig = b;
      });
      if (noetig > platz) {
        titel.style.fontSize = Math.max(30, Math.floor(gross * platz / noetig)) + 'px';
      }
    }
    titelAnpassen(true);
    /* Erst mit der echten Schrift stimmt die Messung - die Hausschrift laedt
       nach, vorher misst der Browser die Ersatzschrift. */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(function () { titelAnpassen(true); });
    }
    if (window.ResizeObserver) {
      new ResizeObserver(function () { titelAnpassen(false); }).observe(titel || wurzel);
    } else {
      window.addEventListener('resize', function () { titelAnpassen(false); });
    }

    /* Startzustand */
    if (marke) marke.style.setProperty('--schritt', 0);
    if (zaehler) zaehler.textContent = '01 / ' + ('0' + anzahl).slice(-2);
    slice(wurzel.querySelectorAll('[data-fspm-vor]')).forEach(function (b) {
      if (parseInt(b.getAttribute('data-fspm-vor'), 10) < 0) b.disabled = true;
      if (anzahl < 2 && parseInt(b.getAttribute('data-fspm-vor'), 10) > 0) b.disabled = true;
    });
  }

  /* ------------------------------------------------------------- Aufhaengen */
  function alles(bereich) {
    slice((bereich || document).querySelectorAll('[data-fspm]')).forEach(initMaterial);
    /* US: die Kopfzeile (fskz) initialisiert assets/fs-kopf.js */
    slice((bereich || document).querySelectorAll('[data-fspg]')).forEach(initGalerie);
    slice((bereich || document).querySelectorAll('[data-fspb]')).forEach(initBalken);
    slice((bereich || document).querySelectorAll('[data-fspi]')).forEach(initInfo);
    slice((bereich || document).querySelectorAll('[data-fspl]')).forEach(initLook);
    scKnoepfe(bereich);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alles(document); });
  } else {
    alles(document);
  }
  if (!window.__fspdpBound) {
    window.__fspdpBound = true;
    document.addEventListener('shopify:section:load', function (e) { alles(e.target); });
  }
})();
